"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.cssAnchorName = exports.ProductAreaFilterWithHelp = exports.ProductAreaFilter = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _phrase = _interopRequireDefault(require("../../../libs/translationsUtils/phrase"));

var _InputGroup = _interopRequireDefault(require("@insided/shared/uikit/InputGroup"));

var _preactPortal = _interopRequireDefault(require("preact-portal"));

var _updateQueryFilters = require("@insided/destination/modules/Navigation/shared/updateQueryFilters");

var _classnames = _interopRequireDefault(require("classnames"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var cssAnchorName = 'ideation-product-area-filter';
exports.cssAnchorName = cssAnchorName;

var ProductAreaFilter = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(ProductAreaFilter, _Component);

  var _super = _createSuper(ProductAreaFilter);

  function ProductAreaFilter() {
    var _this$props$selectedP;

    var _this;

    (0, _classCallCheck2.default)(this, ProductAreaFilter);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      selectedProductArea: (_this$props$selectedP = _this.props.selectedProductArea) !== null && _this$props$selectedP !== void 0 ? _this$props$selectedP : null,
      selectedProductAreaBeforeFiltersApply: null,
      setPortal: false
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setSelectedProductArea", function (newProductArea) {
      var _newProductArea$id;

      _this.setState({
        selectedProductArea: (_newProductArea$id = newProductArea === null || newProductArea === void 0 ? void 0 : newProductArea.id) !== null && _newProductArea$id !== void 0 ? _newProductArea$id : null
      });

      ProductAreaFilter.setQueryParams(newProductArea);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "updatePortalSetting", function (evt) {
      _this.setState(function (prevState) {
        return {
          selectedProductAreaBeforeFiltersApply: prevState.selectedProductArea,
          setPortal: evt.detail.display
        };
      });
    });
    return _this;
  }

  (0, _createClass2.default)(ProductAreaFilter, [{
    key: "ListItem",
    value: function ListItem(productArea) {
      var _this2 = this,
          _productArea$id;

      return (0, _preact.h)("li", null, (0, _preact.h)("div", {
        onClick: function onClick() {
          return _this2.setSelectedProductArea(productArea);
        },
        onKeyUp: function onKeyUp(e) {
          return e.code === 'Enter' ? _this2.setSelectedProductArea(productArea) : null;
        },
        role: "button",
        tabIndex: 0,
        className: (0, _classnames.default)('list-item-button', this.state.selectedProductArea === ((_productArea$id = productArea === null || productArea === void 0 ? void 0 : productArea.id) !== null && _productArea$id !== void 0 ? _productArea$id : null) ? 'selected' : '')
      }, (0, _preact.h)("div", {
        className: "vertical-line"
      }), !(productArea !== null && productArea !== void 0 && productArea.name) ? (0, _preact.h)(_phrase.default, {
        p: "all.products"
      }) : (0, _preact.h)("span", null, productArea === null || productArea === void 0 ? void 0 : productArea.name)));
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this3 = this;

      if (typeof window === 'undefined') {
        return;
      }

      window.addEventListener('filter', this.updatePortalSetting);
      window.addEventListener('productAreaFilterRemoval', function () {
        return _this3.setSelectedProductArea(null);
      });
      window.addEventListener('revertFilters', function () {
        return _this3.setSelectedProductArea(_this3.state.selectedProductAreaBeforeFiltersApply);
      });
      window.addEventListener('resetFilters', function () {
        return _this3.setSelectedProductArea(null);
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this4 = this;

      if (typeof window === 'undefined') {
        return;
      }

      window.removeEventListener('filter', this.updatePortalSetting);
      window.removeEventListener('productAreaFilterRemoval', function () {
        return _this4.setSelectedProductArea(null);
      });
      window.removeEventListener('revertFilters', function () {
        return _this4.setSelectedProductArea(_this4.state.selectedProductAreaBeforeFiltersApply);
      });
      window.removeEventListener('resetFilters', function () {
        return _this4.setSelectedProductArea(null);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;

      var productAreas = this.props.productAreas;
      var setPortal = this.state.setPortal;
      return (0, _preact.h)("div", null, (0, _preact.h)("div", {
        className: (0, _classnames.default)('box__content', 'box__pad', 'ideation-filters', 'is-hidden-M')
      }, (0, _preact.h)("h3", {
        className: "widget-title"
      }, (0, _preact.h)(_phrase.default, {
        p: "filter.by.product"
      })), (0, _preact.h)("ul", {
        className: "ideation-filters__product-area"
      }, this.ListItem(null), productAreas.map(function (productArea) {
        return _this5.ListItem(productArea);
      }))), setPortal && (0, _preact.h)(_preactPortal.default, {
        into: ".instant-search__results-wrapper-filters"
      }, (0, _preact.h)("div", {
        className: (0, _classnames.default)('box__content', 'box__pad', 'ideation-filters')
      }, (0, _preact.h)("h3", {
        className: "widget-title"
      }, (0, _preact.h)(_phrase.default, {
        p: "filter.by.product"
      })), (0, _preact.h)("ul", {
        className: "ideation-filters__product-area"
      }, this.ListItem(null), productAreas.map(function (productArea) {
        return _this5.ListItem(productArea);
      })))));
    }
  }], [{
    key: "setQueryParams",
    value: function setQueryParams(newProductArea) {
      (0, _updateQueryFilters.updateQueryFilters)({
        productArea: newProductArea !== null && newProductArea !== void 0 && newProductArea.id ? [newProductArea.id] : null
      });
    }
  }]);
  return ProductAreaFilter;
}(_preact.Component);

exports.ProductAreaFilter = ProductAreaFilter;

var ProductAreaFilterWithHelp = /*#__PURE__*/function (_Component2) {
  (0, _inherits2.default)(ProductAreaFilterWithHelp, _Component2);

  var _super2 = _createSuper(ProductAreaFilterWithHelp);

  function ProductAreaFilterWithHelp(props) {
    var _this6;

    (0, _classCallCheck2.default)(this, ProductAreaFilterWithHelp);
    _this6 = _super2.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this6), "state", {
      title: _this6.props.title
    });
    _this6.onChangeTitle = _this6.onChangeTitle.bind((0, _assertThisInitialized2.default)(_this6));
    return _this6;
  }

  (0, _createClass2.default)(ProductAreaFilterWithHelp, [{
    key: "onChangeTitle",
    value: function onChangeTitle(newTitle) {
      var _this7 = this;

      this.setState({
        title: newTitle
      }, function () {
        return _this7.props.onChange(_this7.state);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this8 = this;

      var title = this.state.title;
      return (0, _preact.h)("div", {
        className: ""
      }, (0, _preact.h)(_InputGroup.default, {
        title: "Title",
        name: "title",
        placeholder: "Add a title",
        type: "text",
        onChange: function onChange(event) {
          _this8.onChangeTitle(event.target.value);
        },
        value: title
      }));
    }
  }]);
  return ProductAreaFilterWithHelp;
}(_preact.Component);

exports.ProductAreaFilterWithHelp = ProductAreaFilterWithHelp;
var _default = ProductAreaFilter;
exports.default = _default;